import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { useNavigate } from 'react-router-dom';
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  setDoc,
  getDoc
} from "firebase/firestore";
import './AdminDashboard.css';

const AdminUserQuestPage = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [globalQuests, setGlobalQuests] = useState([]);
  const [userQuestProgress, setUserQuestProgress] = useState({});

  // Load all users
  const loadUsers = async () => {
    const snapshot = await getDocs(collection(db, 'users'));
    const userList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setUsers(userList);
  };

  // Load global quests
  const loadGlobalQuests = async () => {
    const snapshot = await getDocs(collection(db, 'quests'));
    const quests = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setGlobalQuests(quests);
  };

  // Load selected user's quest progress
  const loadUserQuestProgress = async (userId) => {
    if (!userId) {
      setUserQuestProgress({});
      return;
    }
    const colRef = collection(db, 'users', userId, 'questProgress');
    const snapshot = await getDocs(colRef);
    const progressData = {};
    snapshot.forEach(doc => {
      progressData[doc.id] = doc.data();
    });
    setUserQuestProgress(progressData);
  };

  useEffect(() => {
    loadUsers();
    loadGlobalQuests();
  }, []);

  useEffect(() => {
    if (selectedUser) {
      loadUserQuestProgress(selectedUser);
    }
  }, [selectedUser]);

  // Handle manual update
  const handleSaveProgress = async (questId, progress, completed) => {
    if (!selectedUser) {
      alert("Select a user first!");
      return;
    }
    const userQuestRef = doc(db, 'users', selectedUser, 'questProgress', questId);
    await setDoc(userQuestRef, {
      progress: Number(progress),
      completed
    }, { merge: true });

    alert("✅ Progress updated!");
    loadUserQuestProgress(selectedUser);
  };

  return (
    <div className="admin-container">
      <h2>🗺️ Admin Quest Progress Editor</h2>

      <div className="admin-section">
        <h3>Select User</h3>
        <select
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="">-- Select a User --</option>
          {users.map(u => (
            <option key={u.id} value={u.id}>
              {u.pseudo || u.id}
            </option>
          ))}
        </select>
      </div>

      {selectedUser && (
        <div className="admin-section">
          <h3>Quests for {users.find(u => u.id === selectedUser)?.pseudo}</h3>
          {globalQuests.length === 0 ? (
            <p>No quests defined.</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Goal</th>
                  <th>Progress</th>
                  <th>Completed</th>
                  <th>Save</th>
                </tr>
              </thead>
              <tbody>
                {globalQuests.map(q => {
                  const userProgress = userQuestProgress[q.id] || { progress: 0, completed: false };
                  return (
                    <tr key={q.id}>
                      <td>
                        {q.imageUrl && (
                          <img
                            src={q.imageUrl}
                            alt={q.title}
                            style={{
                              width: "64px",
                              height: "64px",
                              objectFit: "cover",
                              borderRadius: "8px"
                            }}
                          />
                        )}
                      </td>
                      <td>{q.title}</td>
                      <td>{q.description}</td>
                      <td>{q.goal}</td>
                      <td>
                        <input
                          type="number"
                          value={userProgress.progress}
                          onChange={(e) => {
                            const val = Number(e.target.value);
                            setUserQuestProgress(prev => ({
                              ...prev,
                              [q.id]: {
                                ...userProgress,
                                progress: val
                              }
                            }));
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          checked={userProgress.completed}
                          onChange={(e) => {
                            const val = e.target.checked;
                            setUserQuestProgress(prev => ({
                              ...prev,
                              [q.id]: {
                                ...userProgress,
                                completed: val
                              }
                            }));
                          }}
                        />
                      </td>
                      <td>
                        <button
                          onClick={() => handleSaveProgress(q.id, userProgress.progress, userProgress.completed)}
                        >
                          Save
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

      )}
      <div className="tournament-actions" style={{ marginTop: '20px' }}>
        <button onClick={() => navigate('/admin-panelx-952504')}>⬅️ Back to Dashboard</button>
      </div>
    </div>
  );
};

export default AdminUserQuestPage;
